import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUmbrella = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M22 12a10 10 0 0 0-20 0z" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 12v6.5a2.5 2.5 0 0 0 5 0" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 2,
			x2: 12,
			y2: 4
		})
	]
});
export default SvgUmbrella;
